import { useCallback } from 'react'
import { updateMagnetizingLineStyles } from './utils'

export const useMagnetizingLine = (
  magnetizingLineRef: React.RefObject<HTMLDivElement | null>
) => {
  const show = useCallback(
    (newPosition: number) => {
      if (magnetizingLineRef.current) {
        updateMagnetizingLineStyles(
          magnetizingLineRef.current,
          'block',
          newPosition
        )
      }
    },
    [magnetizingLineRef]
  )

  const hide = useCallback(() => {
    if (magnetizingLineRef.current) {
      updateMagnetizingLineStyles(magnetizingLineRef.current, 'none', 0)
    }
  }, [magnetizingLineRef])

  const handleMagnetizingLine = useCallback(
    (isMagnetizing: boolean, magnetizePosition: number | undefined) => {
      if (isMagnetizing && magnetizePosition !== undefined) {
        show(magnetizePosition)
      } else {
        hide()
      }
    },
    [show, hide]
  )

  return { handleMagnetizingLine, hide }
}
